<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22"
              >
                <i class="bx bx-world bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <div class="row">
                <div class="col-sm-9">
                  <h5 class="mt-3">
                    {{ $t("nlp.natural-language-processing") }}
                  </h5>
                </div>
                <div class="col-sm-3 text-right">
                  <select
                    name="type"
                    id=""
                    class="form-control px-3"
                    v-model="nlp_type"
                    @change="resetResult"
                  >
                    <option value="language-detection">
                      {{ $t("nlp.language-detection") }}
                    </option>
                    <option value="entity-extraction">
                      {{ $t("nlp.entity-extraction") }}
                    </option>
                    <option value="article-extraction">
                      {{ $t("nlp.article-extraction") }}
                    </option>
                    <option value="sentiment-analysis">
                      {{ $t("nlp.sentiment-analysis") }}
                    </option>
                    <option value="embeddings">
                      {{ $t("nlp.embeddings") }}
                    </option>
                    <!-- <option value="summarize">
                      {{ $t("nlp.summarize") }}
                    </option> -->
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5 mb-4">
            <div class="col-sm-12 mb-2">
              <h4>
                <span v-if="nlp_type == 'language-detection'">
                  {{ $t("nlp.language-detection") }}</span
                >
                <span v-if="nlp_type == 'entity-extraction'">
                  {{ $t("nlp.entity-extraction") }}</span
                >
                <span v-if="nlp_type == 'article-extraction'">
                  {{ $t("nlp.article-extraction") }}</span
                >
                <span v-if="nlp_type == 'sentiment-analysis'">
                  {{ $t("nlp.sentiment-analysis") }}</span
                >
                <span v-if="nlp_type == 'embeddings'">
                  {{ $t("nlp.embeddings") }}</span
                >
                <!-- <span v-if="nlp_type == 'summarize'">
                  {{ $t("nlp.summarize") }}</span
                > -->
              </h4>
            </div>

            <div
              class="col-sm-12 mb-2"
              v-if="
                nlp_type == 'language-detection' ||
                nlp_type == 'entity-extraction' ||
                nlp_type == 'sentiment-analysis'
              "
            >
              <div class="text-right">
                <textarea
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="text_value"
                  placeholder="Text ..."
                  aria-describedby="search"
                  style="height: 150px"
                />
              </div>
            </div>
            <div class="col-sm-12 mb-2" v-if="nlp_type == 'article-extraction'">
              <div class="text-right">
                <input
                  id="url"
                  type="text"
                  class="form-control"
                  v-model="nlp_url"
                  placeholder="Url ..."
                  aria-describedby="search"
                />
              </div>
            </div>
            <div class="col-sm-12 mb-2" v-if="nlp_type == 'embeddings'">
              <label for=""> Word </label>
              <div class="text-right">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="nlp_word"
                  v-on:input="removeSpace(nlp_word)"
                  placeholder="word..."
                  aria-describedby="search"
                />
              </div>
            </div>
            <div
              class="col-sm-12 mb-2 mt-2"
              v-if="
                nlp_type == 'entity-extraction' ||
                nlp_type == 'sentiment-analysis' ||
                nlp_type == 'embeddings'
              "
            >
              <label for=""> Lang</label>
              <div class="text-right">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="nlp_lang"
                  placeholder="Lang ..."
                  aria-describedby="search"
                />
              </div>
            </div>
            <div class="col-sm-12 mr-2">
              <div
                class="btn btn-success btn-block py-2 mr-2"
                @click="SearchResult"
              >
                <b-spinner
                  v-if="loading_search"
                  label="Loading ..."
                  small
                ></b-spinner>
                <span v-if="!loading_search"> Submit </span>
                <span v-if="loading_search"> Loading.. </span>
              </div>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading_search"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>
          <div class="col-sm-12" v-if="!loading_search">
            <div class="row mt-5" v-if="result_lang.language">
              <div class="col-12">
                <div class="border p-2">
                  <h5 class="mt-2">Result Info</h5>
                  <hr />
                  <div>
                    <b>Message : </b>
                    {{ result_lang.message }}
                  </div>
                  <div class="mt-2">
                    <b>Language : </b>
                    <span class="btn btn-sm btn-light mr-1 mb-1 text-secondary">
                      {{ result_lang.language }}
                      <img
                        src="https://flagicons.lipis.dev/flags/4x3/gb-eng.svg"
                        width="20"
                        alt=""
                        srcset=""
                        v-if="result_lang.language == 'en'"
                      />
                      <img
                        src="https://flagicons.lipis.dev/flags/4x3/id.svg"
                        width="20"
                        alt=""
                        srcset=""
                        v-if="result_lang.language == 'id'"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5" v-if="result_entities.polyglot">
              <div class="col-12">
                <div class="border p-2">
                  <h5 class="mt-2">Result Info</h5>
                  <hr />
                  <div>
                    <b>Message : </b>
                    {{ result_entities.message }}
                  </div>

                  <div class="mt-2" v-if="result_entities.polyglot">
                    <b>Entities : </b>
                    <span
                      v-for="(ent, index) in result_entities.polyglot.entities"
                      :key="index"
                      class="btn btn-sm btn-light mr-1 mb-1 text-secondary"
                      >{{ removeCharacter(ent) }}
                    </span>
                  </div>

                  <div class="mt-2" v-if="result_entities.polyglot">
                    <b>Entities Type : </b>
                    <span
                      v-for="(ent, index) in result_entities.polyglot
                        .type_entities"
                      :key="index"
                      class="btn btn-sm btn-light mr-1 mb-1 text-secondary"
                      >{{ removeCharacter(ent) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5" v-if="result_sentiment.sentiment !== ''">
              <div class="col-12">
                <div class="border p-2">
                  <h5 class="mt-2">Result Info</h5>

                  <hr />
                  <div>
                    <b>Message : </b>
                    {{ result_sentiment.message }}
                  </div>
                  <div class="mt-2">
                    <b>Sentiment : </b>
                    <span
                      v-if="result_sentiment.sentiment < 0"
                      class="text-danger"
                    >
                      <span class="btn btn-danger btn-sm"> Negative </span>
                    </span>
                    <span
                      v-if="result_sentiment.sentiment == 0"
                      class="text-info"
                    >
                      <span class="btn btn-info btn-sm"> Netral </span>
                    </span>
                    <span
                      v-if="result_sentiment.sentiment > 0"
                      class="text-success"
                    >
                      <span class="btn btn-success btn-sm">
                        <i class="fa fa-plus"></i> Positive
                      </span>
                    </span>
                  </div>

                  <div class="mt-2">
                    <b>Score : </b>
                    <span
                      v-if="result_sentiment.sentiment < 0"
                      class="text-danger"
                      ><b> {{ result_sentiment.sentiment }} </b>
                    </span>
                    <span
                      v-if="result_sentiment.sentiment == 0"
                      class="text-info"
                      ><b> {{ result_sentiment.sentiment }} </b>
                    </span>
                    <span
                      v-if="result_sentiment.sentiment > 0"
                      class="text-success"
                    >
                      <b> {{ result_sentiment.sentiment }} </b>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5" v-if="result_embeddings.neighbours">
              <div class="col-12">
                <div class="border p-2">
                  <h5 class="mt-2">Result Info</h5>
                  <hr />
                  <div>
                    <b>Message : </b>
                    {{ result_embeddings.message }}
                  </div>
                  <div class="mt-2">
                    <b>Neighbours : </b>
                    <span
                      v-for="(skills, index) in result_embeddings.neighbours"
                      :key="index"
                      class="btn btn-sm btn-light mr-1 mb-1 text-secondary"
                      >{{ skills }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5" v-if="result_article.title">
              <div class="col-6">
                <h4 class="my-1">{{ result_article.title }}</h4>
                <small class="text-muted mb-2"
                  >{{ result_article.publish_date }} -
                  {{ result_article.meta_data.content_author }}</small
                >
                <img
                  :src="result_article.top_image"
                  class="mb-2 rounded mr-2 mt-1 w-100"
                />
                <div class="bg-light p-2">
                  <small class="text-muted">{{
                    result_article.meta_description
                  }}</small>
                </div>
                <p class="text-justify">{{ result_article.text }}</p>
              </div>
              <div class="col-6">
                <div class="border p-2">
                  <h5 class="mt-2">News Info</h5>
                  <hr />
                  <div>
                    <b>Site Name : </b>
                    {{ result_article.meta_data.og.site_name }}
                  </div>
                  <div>
                    <b>Type : </b>
                    {{ result_article.meta_data.og.type }}
                  </div>
                  <div>
                    <b>Author : </b> {{ result_article.meta_data.author }}
                  </div>
                  <div>
                    <b>Content Author : </b>
                    {{ result_article.meta_data.content_author }}
                  </div>
                  <div>
                    <b>Content Author ID : </b>
                    {{ result_article.meta_data.content_author_id }}
                  </div>
                  <div>
                    <b>Content Category : </b>
                    {{ result_article.meta_data.content_category }}
                  </div>
                  <div>
                    <b>Content Editor : </b>
                    {{ result_article.meta_data.content_editor }}
                  </div>
                  <div>
                    <b>Content Editor ID : </b>
                    {{ result_article.meta_data.content_editor_id }}
                  </div>
                  <div>
                    <b>Content Lipsus : </b>
                    {{ result_article.meta_data.content_lipsus }}
                  </div>
                  <div>
                    <b>Content Location : </b>
                    {{ result_article.meta_data.content_location }}
                  </div>
                  <div>
                    <b>Content Subcategory : </b>
                    {{ result_article.meta_data.content_subcategory }}
                  </div>
                  <div>
                    <b>Content Type : </b>
                    {{ result_article.meta_data.content_type }}
                  </div>
                  <div>
                    <b>Content Tag : </b>
                    {{ result_article.meta_data.content_tag }}
                  </div>
                  <div>
                    <b>Content Tags : </b>
                    {{ result_article.meta_data.content_tag }}
                  </div>
                  <div>
                    <b>Content Total Words : </b>
                    {{ result_article.meta_data.content_total_words }}
                  </div>
                  <div>
                    <b>Language : </b>
                    {{ result_article.meta_lang }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            class="col-sm-12 text-center"
            v-if="
              (!result_lang.language || !result_article[0]) &&
              !loading_search &&
              search &&
              error == ''
            "
          >
            <p class="text-secondary p-5">{{ $t("overview.table.all.dnf") }}</p>
          </div> -->
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import NlpService from "@/helpers/nlp.service.js";
import TargetService from "@/helpers/target-profile.service";
import Swal from "sweetalert2";
import PreferenceService from "@/helpers/preference.service.js";

export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      nlp_type: "language-detection",
      nlp_lang: "id",
      result_lang: [],
      result_article: [],
      result_entities: {
        message: "",
        polyglot: "",
      },
      result_sentiment: {
        message: "",
        sentiment: "",
      },
      result_embeddings: {
        message: "",
        neighbours: "",
      },
      nlp_url: "",
      nlp_word: "",
      text_value: "",
      target_data: "",
      elastic: {},
      // id_target: this.$route.query.target,
      loading_search: "",
      error: "",
      search: false,
      searchKey: "",
      total_results: "",
      tableData: [
        // { "is_hoax": 0, "author": "-", "content": "Bola.net - Ketua Umum (Ketum) PSSI, Mochamad Iriawan atau yang akrab disapa Iwan Bule memastikan, sponsor untuk Liga 1 2022/2023 tidak akan mengalami perubahan. Artinya, kompetisi kasta tertinggi sepak bola di Tanah Air itu masih disponsori oleh Bank Rakyat Indonesia (BRI). \"BRI masih akan tetap menjadi sponsor. Ini karena yang lain sedang merangkak akibat terkena badai COVID-19,\" ujar Iwan Bule, di Wisma Kemenpora, Senayan, Jakarta Pusat, Selasa (19/7). \"Tapi itu juga tergantung nantinya, ke depan kalau ada sponsor lagi mungkin kami akan sandingkan,\" katanya menambahkan. Mantan Kapolda Metro Jaya ini pun memberikan apresiasi kepada BRI. Bank milik BUMN itu sudah menjadi sponsor Liga 1 sejak musim kemarin. \"Alhamdulillah makasih karena masih setia menjadi sponsor,\" ucapnya. Baca halaman berikutnya ya Bolaneters.", "image": "https://cdns.klimg.com/bola.net/library/upload/21/2021/09/logo-bri-liga-1-2021_a1df022.jpg", "published_at": "Tue, 19 Jul 2022 07:00:00 GMT", "source": "news.google.com", "title": "Iwan Bule: BRI Masih Jadi Sponsor Liga 1", "url": "https://www.bola.net/indonesia/iwan-bule-bri-masih-jadi-sponsor-liga-1-7bde76.html" },
        // { "is_hoax": 0, "author": "Detiktv", "content": "Ketua Umum PSSI Mochamad Iriawan merangkul Shin Tae-yong seusai Timnas Indonesia U-19 tersingkir di Piala AFF U-19 2022. Ia berterima kasih kepada upaya gigih skuad Garuda Nusantara. ADVERTISEMENT SCROLL TO RESUME CONTENT", "image": "https://akcdn.detik.net.id/api/wm/2022/07/10/shin-tae-yong-mochamad-iriawan_169.jpeg?wid=54&w=650&v=1&t=jpeg", "published_at": "Mon, 11 Jul 2022 07:00:00 GMT", "source": "news.google.com", "title": "Momen Iwan Bule Peluk Shin-Tae-yong Usai Timnas U-19 Tersingkir", "url": "https://sport.detik.com/sepakbola/detiktv/d-6172780/momen-iwan-bule-peluk-shin-tae-yong-usai-timnas-u-19-tersingkir" },
        // { "is_hoax": 0, "author": "Eko Isdiyanto", "content": "Kabarkan Kondisi Timnas U-20 Indonesia, Iwan Bule Diserang Netizen Sabtu, 10 September 2022 | 17:26 WIB Ketua Umum PSSI, Mochamad Iriawan, saat ditemui di Stadion Si Jalak Harupat Soreang, Bandung, Jawa Barat, Minggu (28/8/2022). BOLASTYLO.COM - Ketua Umum PSSI, Mochamad Iriawan jadi target serangan netizen Tanah Air saat kabarkan kondisi timnas U-20 Indonesia yang tengah berlatih di Surabaya. Melalui akun Instagram pribadi, Mochamad Iriawan alias Iwan Bule mengunggah tulisan berisi kabar terkini timnas U-20 Indonesia yang berada di Surabaya. Timnas U-20 Indonesia tengah menjalani persiapan terakhir sebelum berlaga di Kualifikasi Piala Asia U-20 2023 di Stadion Gelora Bung Tomo, Surabaya \"Tiba di Surabaya, Tim U-20 Indonesia langsung jalani latihan taktikal.\" isi tulisan dalam sebuah foto yang diunggah Iwan Bule. Lebih lanjut, Iwan Bule juga menuliskan berapa pemain yang dibawa Shin Tae-yong ke Surabaya dan berapa yang akan dimainkan di babak kualifikasi tersebut. Baca Juga: Persija Jakarta Diseret PSSI ke Pusaran Drama Stadion JIS Kondisi para pemain menurut Iwan Bule juga sangat baik dan tidak ada yang cedera, sementara fokus latihan ada pada taktik dan organisasi permainan. \"Timnas U-20 sudah sampai di Surabaya didampingi Coach @shintaeyong7777. Sebanyak 30 pemain diterbangkan ke Surabaya, namun hanya 23 pemain yang akan tampil di lapangan,\" tulis Iwan Bule. \"Sesampainya di Surabaya, Timnas U-20 langsung menjalani latihan di lapangan Thor. Kondisi para pemain sangat baik tanpa cidera. \"Latihan juga difokuskan ke taktik dan organisasi permainan.\" imbuhnya. Baca Juga: Bek Persib Bandung Was-was, Hanya Berharap Hal Ini saat Lawan Arema FC View this post on Instagram A post shared by Mochamad Iriawan - Iwan Bule (@mochamadiriawan84) Unggahan itu ternyata mendapa respons cukup keras dari pecinta sepak bola Tanah Air, bukan soal persiapan timnas U-20 Indonesia di Surabaya. Akan tetapi banyak netizen yang menyinggung soal venue FIFA Matchday timnas Indonesia melawan Curacao yang batal digelar di Jakarta International Stadium (JIS). Sedianya akan digelar di Gelora Bandung Lautan Api (GBLA) pada 24 September 2022, Jawa Barat, dan direncanakan di Jakarta International Stadium (JIS) pada 27 September 2022. Namun untuk laga kedua, PSSI memutuskan untuk tetap menggelar pertandingan di Stadion GBLA. Baca Juga: Turun Kasta ke Liga 2, Cristian Gonzales Benar-benar Sudah Habis? Menurut mereka Stadion JIS tidak jadi digunakan lantaran diklaim tidak memenuhi standar FIFA dan biayanya mahal. Respons netizen Tanah Air cukup keras soal hal ini, bahkan hasrat politik Iwan Bule disebut-sebut sebagai alasan di balik pemilihan GBLA ketimbang JIS. Berikut beberapa komentar pedas netizen Indonesia terhadap Iwan Bule terkait masalah venue FIFA Matchday Indonesia yang batal digelar di JIS. @uutieey__: \"PSSI BUKAN ALAT POLITIK!,\" @ahmadhanif812: \"Cie yang mau jadi gubernur,\" @herry_achmad: \"Gini amat punya Ketum PSSI, Payah Sepakbola dibawa ke ranah Politik. Kami warga Jakarta dan Jakmania rindu Persija main di Jakarta...!!!!\" @aisyhafizu4n: \"Gak malu lo pak sepakbola elu campur sama politik,ngotak dunk pak,\" @irwnardi: TOLONG PAK JANGAN NGADI - NGADI BILANG JIS GA STANDAR FIFA. PSSI YANG GA STANDAR FIFA. BANYAK MAFIA NYA,\" @mfarhn_: \"PSSI APA PARPOL SIH SEBENERNYA?\" @jmali28: \"Kerja yg bener pak sekelas jis kok gak dilolosin sedangkan pembuatannya aja udah mengacu standar fifa apa standar pssi lebih tinggi daripada jis?lawak,\" @chocolotos13_: \"si PALING STANDART FIFA,\" @akbrber: \"Gak malu komen penuh hujatan terus pak?\" Baca Juga: Kabar Cederanya Ronaldo Kwateh Jadi Konsumsi Banyak Media Vietnam View this post on Instagram A post shared by BolaSport.com (@bolasportcom) Source : bolastylo.bolasport.com Penulis : Eko Isdiyanto Editor : Eko Isdiyanto", "image": "https://asset-a.grid.id/crop/0x0:0x0/700x465/photo/2022/08/28/img-20220828-wa0000jpg-20220828042254.jpg", "published_at": "Sat, 10 Sep 2022 07:00:00 GMT", "source": "news.google.com", "title": "Kabarkan Kondisi Timnas U-20 Indonesia, Iwan Bule Diserang Netizen", "url": "https://bolastylo.bolasport.com/read/173471807/kabarkan-kondisi-timnas-u-20-indonesia-iwan-bule-diserang-netizen" },
        // { "is_hoax": 0, "author": "Gilang Romadhan", "content": "Minggu, 7 Agustus 2022 | 13:13 WIB Kapten Timnas U16 Indonesia, Iqbal Gwijangge (kanan) bersama pelatih Bima Sakti. (Sumber: Antara Foto/Michael Siahaan) Penulis : Gilang Romadhan | Editor : Purwanto SLEMAN, KOMPAS.TV - Ketua Umum (Ketum) PSSI Mochamad Iriawan atau yang sering disapa Iwan Bule berniat menjadikan kapten Timnas U16 Indonesia, Iqbal Gwajingge sebagai anak angkat. Hal tersebut diungkapkan Iwan selepas pertandingan terakhir Grup A Piala AFF U16 2022 antara Indonesia vs Vietnam di Stadion Maguwoharjo, Sleman, Sabtu (6/8/2022) malam WIB. Iwan mengaku ingin mengawal karier dan membiayai hidup Iqbal sampai mendapatkan pekerjaan. \"Saya akan kawal sampai dia lulus dan mendapatkan pekerjaan,\" terang Iwan Bule, dikutip dari Antara. Baca Juga: Kabar Baik di Piala AFF U16 2022: Sukses ke Semifinal, Timnas Indonesia Diguyur Bonus Rp100 Juta Iqbal Gwajingge sendiri tampil cemerlang selama gelaran Piala AFF U16 2022. Pemain berdarah Papua kelahiran Sumedang, Jawa Barat itu selalu menjadi kepercayaan pelatih Bima Sakti. Posisinya sebagai bek tengah tidak tergantikan. Sebagai catatan, Indonesia memiliki rekor 13 gol dan baru satu kali kebobolan selama 3 pertandingan fase grup Piala AFF U16 2022. Satu-satunya gol yang masuk ke gawang Indonesia adalah penalti pemain Vietnam, Nguyen Chong. Mendengar niat baik dari Iwan Bule, Iqbal Gwajingge mengaku sangat senang. Dirinya menyambut baik niat dari sang Ketum PSSI. \"Alhamdulillah, orang tua saya juga bilang alhamdulillah,\" terang Iqbal. Baca Juga: Piala AFF U16: Timnas Indonesia Diyakini Bisa Lumat Vietnam dan Lolos Semifinal, Ini Analisisnya Terlepas dari itu, Indonesia akan menghadapi juara Grup C di babak semifinal yang diselenggarakan 10 Agustus 2022 di Stadion Maguwoharjo. Di Grup C sendiri, Malaysia, Myanmar, dan Kamboja masih memiliki peluang untuk lolos ke semifinal sebagai juara grup.", "image": "https://media-origin.kompas.tv/library/image/content_article/article_img/20220807051915.jpg", "published_at": "Sun, 07 Aug 2022 07:00:00 GMT", "source": "news.google.com", "title": "Iwan Bule Berniat Jadikan Kapten Timnas U16 Indonesia Sebagai Anak Angkat", "url": "https://archive.cob.web.id/archive/1666173988.668352/singlefile.html" }
      ],
      dnf: false,
      dnfp: false,
      is_spam: "",
      search: false,
      title: "NLP",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "NLP",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          label: "#",
        },
        { key: "bulk", thStyle: { width: "2%" }, label: "#" },
        {
          key: "published",
          thStyle: { width: "10%" },
          label: this.$t("news.published_at"),
        },
        {
          key: "image",
          thStyle: { width: "10%" },
          label: this.$t("news.image"),
        },
        {
          key: "title",
          thStyle: { width: "30%" },
          label: this.$t("news.title"),
        },
        {
          key: "content",
          thStyle: { width: "40%" },
          label: this.$t("news.content"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("news.actions"),
        },
      ],
      target: {
        tableData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "name",
        sortDesc: false,
        fields: [
          {
            key: "target",
            label: this.$t("news.target-profile"),
            sortable: true,
          },
          {
            key: "description",
            label: this.$t("news.description"),
            sortable: true,
          },
          { key: "category", label: this.$t("news.category"), sortable: true },
          {
            key: "actions",
            label: this.$t("table.citizen.th.action"),
            class: "text-center",
          },
        ],
      },
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    rows_target() {
      return this.target.tableData.length;
    },
    criteria() {
      return this.searchTarget.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      let element = [];
      try {
        for (let i = 0; i < this.relation.length; i++) {
          element.push(JSON.parse(this.relation[i]).id);
        }
      } catch (e) {
        element = [];
      }
      const options = this.options.filter(
        (opt) => element.indexOf(opt.id) === -1
      );
      this.show = false;
      if (criteria) {
        this.show = true;
        return options.filter((opt) =>
          opt.name.toLowerCase().includes(criteria)
        );
      }
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return this.$t("wizard.form.validation.not_match1");
      }
      return "";
    },
    validFormat() {
      if (this.validformat != null) {
        if (this.validformat) {
          return "is-valid";
        } else {
          return "is-invalid";
        }
      }
    },
  },
  methods: {
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[1].ip_address;
        })
        .catch((err) => {
          // console.log(err);
        });
    },

    getTargetProfile() {
      if (this.id_target != "" && this.id_target != null) {
        TargetService.getDetailTarget(this.id_target)
          .then((response) => {
            let data = {
              title: response.data.data.title,
              id: response.data.data.id_target,
            };
            this.target_data = data;
          })
          .catch((err) => {
            console.log("err ", err);
          });
      }
    },

    select() {
      // console.log('selected');
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i]);
        }
      }
    },

    onFilteredTarget(filteredItems) {
      this.target.totalRows = filteredItems.length;
      this.target.currentPage = 1;
    },

    author(data) {
      return data[0] ?? "-";
    },

    listProfile() {
      TargetService.getTargetBy()
        .then((response) => {
          response.data.data.forEach((element) => {
            const data = {
              id_target: element.id_target,
              title: element.title,
              image_project: element.image_project,
              description: element.description,
              category: element.category.category_name,
              updated_at: element.updated_at,
            };
            this.target.tableData.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    SearchResult() {
      this.error = "";
      this.loading_search = true;
      this.search = true;
      this.tableData = [];

      const params_value_lang = {
        text: this.text_value,
      };
      const body_entity_extraction = {
        text: this.text_value,
        lang: this.nlp_lang,
      };
      const params_value_url = {
        url: this.nlp_url,
      };

      if (this.nlp_type == "language-detection") {
        // console.log("pvl", params_value_lang);
        this.resetResult();
        this.loading_search = false;
        NlpService.searchLang(this.elastic, params_value_lang)
          .then((response) => {
            // console.log("res nlp lang ", response);
            const res = response.data;
            this.result_lang = {
              language: res.langid.language,
              message: res.message,
            };
            this.search = true;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.loading_search = false;
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            }
          });
      } else if (this.nlp_type == "entity-extraction") {
        this.resetResult();
        // console.log("pventity", body_entity_extraction);
        this.loading_search = true;
        const formData = new FormData();
        formData.append("text", this.text_value);
        formData.append("lang", this.nlp_lang);
        // console.log("fd", formData);

        NlpService.entityExtraction(this.elastic, formData)
          .then((response) => {
            // console.log("res nlp enty ", response);
            const res = response.data;
            this.result_entities = res;

            this.result_entities = {
              message: res.message,
              polyglot: res.polyglot,
            };
            this.search = true;
            this.loading = false;
            this.loading_search = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.loading_search = false;
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            }
          });
      } else if (this.nlp_type == "article-extraction") {
        // console.log("pv url article", params_value_url);
        this.resetResult();
        // this.result_article = response.newspaper;
        this.loading_search = true;
        NlpService.searchNews(this.elastic, params_value_url)
          .then((response) => {
            // console.log("res nlp article", response.data);
            const res = response.data;
            this.result_article = res.newspaper;
            this.search = true;
            this.loading = false;
            this.loading_search = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            }
          });
      } else if (this.nlp_type == "sentiment-analysis") {
        this.resetResult();
        const formDataSentiment = new FormData();
        formDataSentiment.append("text", this.text_value);
        formDataSentiment.append("lang", this.nlp_lang);
        // console.log("fd sentiment", formDataSentiment);

        NlpService.searchSentiment(this.elastic, formDataSentiment)
          .then((response) => {
            // console.log("res nlp snt ", response);
            const res_sentiment = response.data;
            this.result_sentiment = {
              message: res_sentiment.message,
              sentiment: res_sentiment.sentiment,
            };

            this.loading_search = false;
            this.search = true;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.loading_search = false;
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            }
          });
      } else if (this.nlp_type == "embeddings") {
        this.resetResult();
        const params_value_embeddings = {
          word: this.nlp_word,
          lang: this.nlp_lang,
        };

        NlpService.searchEmbeddings(this.elastic, params_value_embeddings)
          .then((response) => {
            // console.log("res nlp embd ", response);
            const res = response.data;
            this.result_embeddings = {
              message: res.message,
              neighbours: res.neighbours,
            };

            this.search = true;
            this.loading = false;
            this.loading_search = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.loading_search = false;
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            }
          });
      }
    },

    clearData() {
      this.tableData = [];
      this.searchKey = "";
      this.selected = [];
      this.search = false;
    },

    onOptionClick(option) {
      this.relation.push({
        name: option.name,
        id: option.id,
        image: option.image,
      });
      this.show = false;
      this.search = "";
    },

    resetResult() {
      this.result_lang = [];
      this.result_article = [];
      this.result_entities = {
        message: "",
        polyglot: "",
      };
      this.result_sentiment = {
        message: "",
        sentiment: "",
      };
      this.result_embeddings = {
        message: "",
        neighbours: "",
      };
    },

    removeSpace(value) {
      const word = this.nlp_word;
      const str = word.replace(/\s+/g, "");
      this.nlp_word = str;
      // console.log(str);
    },

    removeCharacter(val) {
      let et = JSON.stringify(val);
      const hasil = et
        .replace("{", "")
        .replace("}", "")
        .replace("[", "")
        .replace("]", "");
      // console.log(hasil);
      return hasil;
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD hh:mm");
    },
  },
  beforeMount() {
    this.listProfile();
  },
  mounted() {
    this.totalRows = this.items.length;
    // this.getNewsInfo();
    this.getPreferences();
    this.getTargetProfile();
    this.availableOptions;
  },
};
</script>

<style scoped>
.image {
  height: 250px;
}
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>
